function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _regeneratorKeys(e) {
  var n = Object(e),
    r = [];
  for (var t in n) r.unshift(t);
  return function e() {
    for (; r.length;) if ((t = r.pop()) in n) return e.value = t, e.done = !1, e;
    return e.done = !0, e;
  };
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(t, e) {
  if (e && ("object" == _typeof(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}
function _superPropGet(t, o, e, r) {
  var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e);
  return 2 & r && "function" == typeof p ? function (t) {
    return p.apply(e, t);
  } : p;
}
function _get() {
  return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) {
    var p = _superPropBase(e, t);
    if (p) {
      var n = Object.getOwnPropertyDescriptor(p, t);
      return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value;
    }
  }, _get.apply(null, arguments);
}
function _superPropBase(t, o) {
  for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t)););
  return t;
}
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf(t);
}
function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && _setPrototypeOf(t, e);
}
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}
var OnePlayerGameTemplate = require('../../lib/templates/oneplayer-gametemplate');
var SolitrioGameRulesTemplate = require('./lib/solitrio-game-rules.template');
var SolitrioGameOptions = require('./lib/solitrio-game-options');
var htmlTemplate = require('./lib/game-html.template');

//////////////////
// CONSTRUCTOR  //
//////////////////
var Solitrio = /*#__PURE__*/function (_OnePlayerGameTemplat) {
  function Solitrio(app) {
    var _this;
    _classCallCheck(this, Solitrio);
    _this = _callSuper(this, Solitrio, [app]);
    _this.name = 'Solitrio';
    _this.slug = 'solitrio';
    _this.game_length = 5; //Estimated number of minutes to complete a game
    _this.description = "Once you've started playing Solitrio, how can you go back to old-fashioned Solitaire? This one-player card game is the perfect way to pass a flight from Hong Kong to pretty much anywhere. Arrange the cards on the table from 2-10 ordered by suite. Harder than it looks and wildly addictive.";
    _this.categories = 'Games Cardgame One-player';
    _this.animationSpeed = 500;
    _this.card_img_dir = '/saito/img/arcade/cards';
    _this.app = app;
    _this.version = '1.1.4';
    return _this;
  }
  _inherits(Solitrio, _OnePlayerGameTemplat);
  return _createClass(Solitrio, [{
    key: "returnGameRulesHTML",
    value: function returnGameRulesHTML() {
      return SolitrioGameRulesTemplate(this.app, this);
    }
  }, {
    key: "hasSettings",
    value: function hasSettings() {
      return true;
    }
  }, {
    key: "loadSettings",
    value: function loadSettings() {
      var container = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      if (!container) {
        this.overlay.show("<div class=\"module-settings-overlay\"><h2>Solitrio Settings</h2></div>");
        container = '.module-settings-overlay';
      }
      var as = new SolitrioGameOptions(this.app, this, container);
      as.render();
    }
  }, {
    key: "initializeGame",
    value: function initializeGame(game_id) {
      console.log('SET WITH GAMEID: ' + game_id);
      if (!this.game.state) {
        console.log('******Generating the Game******');
        this.game.state = this.returnState();
        this.game.queue = [];
        this.game.queue.push('round');
        this.game.queue.push('READY');
      } else {
        this.game.state = Object.assign(this.returnState(), this.game.state);
        if (this.game.state.game_started) {
          this.game.queue = ['play'];
        }
      }
      console.log(JSON.parse(JSON.stringify(this.game.state)));
      if (this.browser_active) {
        $('.slot').css('min-height', $('.card').css('min-height'));
      }
    }
  }, {
    key: "newRound",
    value: function newRound() {
      //Set up queue
      this.game.queue = [];
      this.game.queue.push('play\t90');
      this.game.queue.push('DEAL\t1\t1\t40');
      this.game.queue.push('SHUFFLE\t1\t1');
      this.game.queue.push('DECK\t1\t' + JSON.stringify(this.returnDeck()));
      this.game.queue.push('clear_board');

      //Reset/Increment State
      this.game.state.recycles_remaining = 2;
      if (this.browser_active) {
        $('#rowbox').removeClass('nomoves');
      }
    }
  }, {
    key: "render",
    value: function () {
      var _render = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(app) {
        var _this2 = this;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              if (!(!this.browser_active || this.initialize_game_run)) {
                _context2.n = 1;
                break;
              }
              return _context2.a(2);
            case 1:
              _context2.n = 2;
              return this.injectGameHTML(htmlTemplate());
            case 2:
              _context2.n = 3;
              return _superPropGet(Solitrio, "render", this, 3)([app]);
            case 3:
              /*if (app.browser.isMobileBrowser(navigator.userAgent)) {
              	this.app.connection.on('browser-fullscreen-toggle', (value) => {
              		if (value) {
              			setTimeout(()=> {
              			    screen.orientation.lock('landscape')
              			    .then(()=> {
              			    	console.log("Lock success");
              			    }).catch((error) => {
              			    	alert(error);
              			    });
              			}, 25);
              		}else{
              			screen.orientation.unlock();
              		}
              	});
              }*/

              //
              // ADD MENU
              //
              this.menu.addMenuOption('game-game', 'Game');
              this.menu.addSubMenuOption('game-game', {
                text: 'Start New Game',
                id: 'game-new',
                "class": 'game-new',
                callback: function () {
                  var _callback = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(app, game_mod) {
                    return _regenerator().w(function (_context) {
                      while (1) switch (_context.n) {
                        case 0:
                          game_mod.menu.hideSubMenus();
                          game_mod.prependMove('lose');
                          _context.n = 1;
                          return game_mod.clearTable();
                        case 1:
                          game_mod.endTurn();
                        case 2:
                          return _context.a(2);
                      }
                    }, _callee);
                  }));
                  function callback(_x2, _x3) {
                    return _callback.apply(this, arguments);
                  }
                  return callback;
                }()
              });
              this.menu.addSubMenuOption('game-game', {
                text: 'Settings',
                id: 'game-settings',
                "class": 'game-settings',
                callback: function callback(app, game_mod) {
                  game_mod.loadSettings();
                }
              });
              this.menu.addSubMenuOption('game-game', {
                text: 'How to Play',
                id: 'game-intro',
                "class": 'game-intro',
                callback: function callback(app, game_mod) {
                  game_mod.menu.hideSubMenus();
                  game_mod.overlay.show(game_mod.returnGameRulesHTML());
                }
              });
              this.menu.addSubMenuOption('game-game', {
                text: 'Stats',
                id: 'game-stats',
                "class": 'game-stats',
                callback: function callback(app, game_mod) {
                  game_mod.menu.hideSubMenus();
                  game_mod.overlay.show(game_mod.returnStatsHTML('Solitrio'));
                }
              });
              this.menu.addChatMenu();
              this.menu.render();
              this.app.connection.on('solitrio-update-settings', function () {
                _this2.attachEventsToBoard();
              });
              document.addEventListener('keydown', function (e) {
                if (e.ctrlKey && e.key === 'z') {
                  var _this2$moves;
                  if ((_this2$moves = _this2.moves) !== null && _this2$moves !== void 0 && _this2$moves.length) {
                    _this2.undoMove();
                  }
                }
              });
            case 4:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function render(_x) {
        return _render.apply(this, arguments);
      }
      return render;
    }()
  }, {
    key: "returnState",
    value: function returnState() {
      var state = _superPropGet(Solitrio, "returnState", this, 3)([]);
      state.recycles_remaining = 2;
      state.game_started = 0;
      return state;
    }
  }, {
    key: "checkBoardStatus",
    value: function () {
      var _checkBoardStatus = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var _this3 = this;
        var winner;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              //Use recycling function to check if in winning state
              this.displayUserInterface();
              _context4.n = 1;
              return this.scanBoard(false);
            case 1:
              winner = _context4.v;
              if (winner) {
                this.prependMove('win');
                this.endTurn();
              } else if (!this.hasAvailableMoves()) {
                if (this.game.state.recycles_remaining == 0) {
                  this.prependMove('lose');
                  this.overlay.show(this.returnStatsHTML('Game over', 1), /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
                    return _regenerator().w(function (_context3) {
                      while (1) switch (_context3.n) {
                        case 0:
                          _context3.n = 1;
                          return _this3.clearTable();
                        case 1:
                          _this3.endTurn();
                        case 2:
                          return _context3.a(2);
                      }
                    }, _callee3);
                  })));
                  $('.stats-menu-controls').html("<button id=\"undo\" class=\"option saito-button-primary\">Go back</button><button id=\"quit\" class=\"option saito-button-primary\">Start Next Game</button>");
                  this.attachHUDEvents();
                  $('.stats-menu-controls .saito-button-primary').on('click', function () {
                    _this3.overlay.hide();
                  });
                } else {
                  this.shuffleFlash();
                  $('#hint').css('display', 'none');
                }
              }
            case 2:
              return _context4.a(2);
          }
        }, _callee4, this);
      }));
      function checkBoardStatus() {
        return _checkBoardStatus.apply(this, arguments);
      }
      return checkBoardStatus;
    }()
  }, {
    key: "attachEventsToBoard",
    value: function attachEventsToBoard() {
      var play_mode = this.loadGamePreference('solitrio-play-mode') || 'auto';
      if (play_mode == 'auto') {
        this.attachEventsToBoardAutomatic();
      } else {
        this.attachEventsToBoardManual();
      }
    }
  }, {
    key: "attachEventsToBoardAutomatic",
    value: function attachEventsToBoardAutomatic() {
      var solitrio_self = this;
      $('.slot').off();
      $('.slot').on('click', function () {
        var card = $(this).attr('id');
        if (solitrio_self.game.board[card][0] === 'E') {
          return;
        }
        solitrio_self.toggleCard(card);
        var slot = solitrio_self.dynamicColoring(card);
        if (slot) {
          //card = selected, slot = card
          solitrio_self.prependMove("move\t".concat(card, "\t").concat(slot));
          var x = JSON.stringify(solitrio_self.game.board[card]);
          var y = JSON.stringify(solitrio_self.game.board[slot]);
          solitrio_self.game.board[card] = JSON.parse(y);
          solitrio_self.game.board[slot] = JSON.parse(x);
          solitrio_self.untoggleCard(card);

          //console.log(`Animate ${x}: ${card} -> ${slot}`);
          solitrio_self.moveGameElement(solitrio_self.copyGameElement("#".concat(card, " img")), "#".concat(slot), {
            /*resize: 1,*/
            insert: 1,
            callback: function callback() {
              $('#' + card).addClass('empty');
              $('#' + slot).removeClass('empty');
            }
          }, function () {
            $('.animated_elem').remove();

            //Redraw whole board
            //for (let i in solitrio_self.game.board) {
            //	let divname = '#' + i;
            //	$(divname).html(solitrio_self.returnCardImageHTML(solitrio_self.game.board[i]));
            //}

            /*$('#' + card).html(
            	solitrio_self.returnCardImageHTML(
            		solitrio_self.game.board[card]
            	)
            );
            $('#' + slot).html(
            	solitrio_self.returnCardImageHTML(
            		solitrio_self.game.board[slot]
            	)
            );*/

            solitrio_self.checkBoardStatus();
          });
        } else {
          $(this).toggleClass('misclick');
          solitrio_self.untoggleCard(card);
        }
      });
    }
  }, {
    key: "attachEventsToBoardManual",
    value: function attachEventsToBoardManual() {
      var solitrio_self = this;
      var selected = ''; // prev selected

      $('.slot').off();
      $('.slot').on('click', function () {
        var card = $(this).attr('id');
        if (selected === card) {
          //Selecting same card again
          solitrio_self.untoggleCard(card);
          selected = '';
          $('#rowbox').removeClass('selected');
          return;
        } else {
          if (!selected) {
            //New Card
            if (solitrio_self.game.board[card][0] !== 'E') {
              selected = card;
              solitrio_self.toggleCard(card);
              $('#rowbox').addClass('selected');
              solitrio_self.dynamicColoring(selected);
              return;
            }
          } else {
            //Change selection
            if (solitrio_self.game.board[card][0] !== 'E') {
              solitrio_self.untoggleCard(selected);
              solitrio_self.toggleCard(card);
              selected = card;
              solitrio_self.dynamicColoring(selected);
              return;
            }

            // Move card to empty slot if it is legal
            // selected must work in this context
            if (solitrio_self.canCardPlaceInSlot(selected, card)) {
              solitrio_self.prependMove("move\t".concat(selected, "\t").concat(card));
              //solitrio_self.endTurn();

              var x = JSON.stringify(solitrio_self.game.board[selected]);
              var y = JSON.stringify(solitrio_self.game.board[card]);
              solitrio_self.game.board[selected] = JSON.parse(y);
              solitrio_self.game.board[card] = JSON.parse(x);
              solitrio_self.untoggleCard(card);
              solitrio_self.untoggleCard(selected);
              $('#' + selected).html(solitrio_self.returnCardImageHTML(solitrio_self.game.board[selected]));
              $('#' + card).html(solitrio_self.returnCardImageHTML(solitrio_self.game.board[card]));
              $('#' + selected).toggleClass('empty');
              $('#' + card).toggleClass('empty');
              $('#rowbox').removeClass('selected');
              selected = '';
              solitrio_self.checkBoardStatus();
              return;
            } else {
              //SmartTip, slightly redundant with internal logic of canCardPlaceInSlot
              var smartTip;
              var predecessor = solitrio_self.getPredecessor(card);
              if (predecessor) {
                var cardValue = parseInt(solitrio_self.returnCardNumber(predecessor)) + 1;
                if (cardValue < 11) smartTip = 'Hint: Try a ' + cardValue + ' of ' + solitrio_self.cardSuitHTML(solitrio_self.returnCardSuite(predecessor));else smartTip = 'Unfortunately, no card can go there';
              } else {
                smartTip = 'Hint: Try a 2 of any suit';
              }
              //Feedback
              $(this).toggleClass('misclick');
              solitrio_self.untoggleCard(selected);
              selected = '';
              $('#rowbox').removeClass('selected');
              return;
            }
          }
        }
      });
    }
  }, {
    key: "shuffleFlash",
    value: function shuffleFlash() {
      $('#rowbox').addClass('nomoves');
      $('#shuffle').css('color', '#000').css('background', '#FFF6').delay(300).queue(function () {
        $(this).css('color', '#FFF').css('background', '#0004').dequeue();
      }).delay(300).queue(function () {
        $(this).css('color', '#000').css('background', '#FFF6').dequeue();
      }).delay(300).queue(function () {
        $(this).css('color', '#FFF').css('background', '#0004').dequeue();
      }).delay(300).queue(function () {
        $(this).css('color', '#000').css('background', '#FFF6').dequeue();
      }).delay(300).queue(function () {
        $(this).css('color', '#FFF').css('background', '#0004').dequeue();
      }).delay(300).queue(function () {
        $(this).css('color', '#000').css('background', '#FFF6').dequeue();
      }).delay(300).queue(function () {
        $(this).css('color', '#FFF').css('background', '#0004').dequeue();
      }).delay(300).queue(function () {
        $(this).css('color', '#000').css('background', '#FFF6').dequeue();
      }).delay(300).queue(function () {
        $(this).removeAttr('style').dequeue();
      });
    }
  }, {
    key: "dynamicColoring",
    value: function dynamicColoring(card) {
      var solitrio_self = this;
      var availableSlot = null;
      $('.valid').removeClass('valid');
      $('.invalid').removeClass('invalid');
      $('.empty').each(function () {
        if (solitrio_self.canCardPlaceInSlot(card, $(this).attr('id'))) {
          availableSlot = $(this).attr('id');
          $(this).addClass('valid');
        } else {
          $(this).addClass('invalid');
        }
      });
      return availableSlot;
    }

    /*
     Card: Previously selected card 
     Slot: empty slot
     Both expressed by position "row[1-4]_slot[1-10]"
     */
  }, {
    key: "canCardPlaceInSlot",
    value: function canCardPlaceInSlot(card, slot) {
      var cardValue = this.returnCardNumber(card);
      var cardSuit = this.returnCardSuite(card);
      var predecessor = this.getPredecessor(slot);
      if (predecessor) {
        var predecessorValueNum = parseInt(this.returnCardNumber(predecessor));
        var predecessorSuit = this.returnCardSuite(predecessor);
        if (cardValue == predecessorValueNum + 1 && cardSuit === predecessorSuit) return true;
      } else {
        //No predecessor, i.e. first position in row
        if (cardValue === '2') return true;
      }
      return false;
    }

    /*
     Return previous position in row for a given coordinate, false if no predecessor
    */
  }, {
    key: "getPredecessor",
    value: function getPredecessor(cardPos) {
      var tempArr = cardPos.split('_slot');
      if (tempArr[1] === '1') return false;else return tempArr[0] + '_slot' + (tempArr[1] - 1);
    }

    /* scan board to see if any legal moves available*/
  }, {
    key: "hasAvailableMoves",
    value: function hasAvailableMoves() {
      for (var i = 1; i <= 4; i++) {
        var prevNum = 'none';
        for (var j = 1; j <= 10; j++) {
          var slot = "row".concat(i, "_slot").concat(j);
          var suite = this.returnCardSuite(slot);
          if (suite === 'E') {
            if (prevNum != '10') return true;
            prevNum = '10'; //Empty slot counts as a 10 because it is "blocking"
          } else prevNum = this.returnCardNumber(slot);
        }
      }
      return false;
    }
  }, {
    key: "toggleCard",
    value: function toggleCard(divname) {
      divname = '#' + divname;
      $(divname).css('opacity', '0.75');
    }
  }, {
    key: "untoggleAll",
    value: function untoggleAll() {
      $('.slot').css('opacity', '1.0');
    }
  }, {
    key: "untoggleCard",
    value: function untoggleCard(divname) {
      divname = '#' + divname;
      $(divname).css('opacity', '1.0');
    }
  }, {
    key: "hideCard",
    value: function hideCard(divname) {
      divname = '#' + divname;
      $(divname).css('opacity', '0.0');
    }
  }, {
    key: "clearTable",
    value: function () {
      var _clearTable = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var i, j, divname;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              $('.option').off();
              $('.slot').off();
              i = 1;
            case 1:
              if (!(i <= 4)) {
                _context5.n = 5;
                break;
              }
              j = 1;
            case 2:
              if (!(j <= 10)) {
                _context5.n = 4;
                break;
              }
              divname = "row".concat(i, "_slot").concat(j);
              this.hideCard(divname);
              _context5.n = 3;
              return this.timeout(15);
            case 3:
              j++;
              _context5.n = 2;
              break;
            case 4:
              i++;
              _context5.n = 1;
              break;
            case 5:
              return _context5.a(2);
          }
        }, _callee5, this);
      }));
      function clearTable() {
        return _clearTable.apply(this, arguments);
      }
      return clearTable;
    }() /* Copy hand into board*/
  }, {
    key: "handToBoard",
    value: function handToBoard() {
      var indexCt = 0;
      for (var i = 1; i <= 4; i++) for (var j = 1; j <= 10; j++) {
        var position = "row".concat(i, "_slot").concat(j);
        this.game.board[position] = this.game.deck[0].cards[this.game.deck[0].hand[indexCt++]];
      }
    }
  }, {
    key: "boardToHand",
    value: function boardToHand() {
      var indexCt = 0;
      for (var position in this.game.board) {
        this.game.deck[0].hand[indexCt++] = this.game.board[position];
      }
    }
  }, {
    key: "parseIndex",
    value: function parseIndex(slot) {
      var coords = slot.split('_');
      var x = coords[0].replace('row', '');
      var y = coords[1].replace('slot', '');
      return 10 * (parseInt(x) - 1) + parseInt(y) - 1;
    }
  }, {
    key: "handleGameLoop",
    value: function handleGameLoop() {
      var _this4 = this;
      var msg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      this.saveGame(this.game.id);
      ///////////
      // QUEUE //
      ///////////
      if (this.game.queue.length > 0) {
        var qe = this.game.queue.length - 1;
        var mv = this.game.queue[qe].split('\t');
        console.log(JSON.stringify(mv));
        if (mv[0] === 'round') {
          this.game.state.game_started = true;
          this.newRound();
        }
        if (mv[0] === 'win') {
          this.game.state.session.round++;
          this.game.state.session.wins++;
          this.overlay.show(this.returnStatsHTML('Congratulations!'), function () {
            _this4.newRound();
            _this4.game.queue.push("ROUNDOVER\t".concat(JSON.stringify([_this4.publicKey]), "\troundover\t").concat(JSON.stringify([])));
            _this4.restartQueue();
          });
          $('.stats-menu-controls').html("<button id=\"quit\" class=\"option saito-button-primary\">Start Next Game</button>");
          $('.stats-menu-controls .saito-button-primary').on('click', function () {
            _this4.overlay.close();
          });
          return 0;
        }
        if (mv[0] === 'lose') {
          this.game.state.session.round++;
          this.game.state.session.losses++;
          this.newRound();
          this.game.queue.push("ROUNDOVER\t".concat(JSON.stringify([]), "\troundover\t").concat(JSON.stringify([this.publicKey])));
        }
        if (mv[0] === 'clear_board') {
          this.game.queue.splice(qe, 1);
          for (var i in this.game.board) {
            var divname = '#' + i;
            $(divname).html('');
          }
          //Clear board
          this.game.board = {};
        }
        if (mv[0] === 'play') {
          if (this.browser_active) {
            this.game.queue.splice(qe, 1);
            this.game.queue.push('play\t90');
            var pause = mv[1] ? parseInt(mv[1]) : 0;
            this.displayUserInterface();
            this.handToBoard();
            setTimeout(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
              return _regenerator().w(function (_context6) {
                while (1) switch (_context6.n) {
                  case 0:
                    _context6.n = 1;
                    return _this4.displayBoard(pause);
                  case 1:
                    _this4.attachEventsToBoard();
                    _this4.checkBoardStatus();
                  case 2:
                    return _context6.a(2);
                }
              }, _callee6);
            })), 25);
          }
          return 0;
        }
        if (mv[0] === 'shuffle') {
          // We return 0 to pause queue execution because the scanBoard is async
          // and we don't want to use an await

          this.game.queue.splice(qe, 1);
          this.scanBoard(true);
          this.game.state.recycles_remaining--;
          return 0;
        }
        if (mv[0] === 'move') {
          this.game.queue.splice(qe, 1);
          var card = mv[1]; //rowX_slotY
          var emptySlot = mv[2]; //rowX_slotY

          var x = this.parseIndex(card);
          var y = this.parseIndex(emptySlot);
          var temp = this.game.deck[0].hand[x];
          this.game.deck[0].hand[x] = this.game.deck[0].hand[y];
          this.game.deck[0].hand[y] = temp;
        }
      }
      return 1;
    }
  }, {
    key: "undoMove",
    value: function undoMove() {
      var mv = this.moves.shift().split('\t');
      if (mv[0] == 'lose' || mv[1] == 'win') {
        this.undoMove();
        return;
      }
      var card = mv[1];
      var selected = mv[2];
      var x = JSON.stringify(this.game.board[selected]);
      var y = JSON.stringify(this.game.board[card]);
      this.game.board[selected] = JSON.parse(y);
      this.game.board[card] = JSON.parse(x);
      $('#' + selected).html(this.returnCardImageHTML(this.game.board[selected]));
      $('#' + card).html(this.returnCardImageHTML(this.game.board[card]));
      $('#' + selected).toggleClass('empty');
      $('#' + card).toggleClass('empty');
      $('#rowbox').removeClass('selected');
      this.untoggleAll();
      this.displayUserInterface();
    }
  }, {
    key: "displayBoard",
    value: function () {
      var _displayBoard = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7() {
        var timeInterval,
          i,
          divname,
          _args7 = arguments,
          _t,
          _t2,
          _t3;
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.p = _context7.n) {
            case 0:
              timeInterval = _args7.length > 0 && _args7[0] !== undefined ? _args7[0] : 0;
              if (!(this.browser_active == 0)) {
                _context7.n = 1;
                break;
              }
              return _context7.a(2);
            case 1:
              $('.slot').removeClass('empty');
              _context7.p = 2;
              _t = _regeneratorKeys(this.game.board);
            case 3:
              if ((_t2 = _t()).done) {
                _context7.n = 5;
                break;
              }
              i = _t2.value;
              _context7.n = 4;
              return this.timeout(timeInterval);
            case 4:
              divname = '#' + i;
              $(divname).html(this.returnCardImageHTML(this.game.board[i]));
              this.untoggleCard(i);
              if (this.game.board[i][0] == 'E') {
                $(divname).addClass('empty');
                $(divname).html("<img src=\"".concat(this.card_img_dir, "/red_back.png\" />"));
                $(divname).children().fadeOut(10 * timeInterval, function () {
                  $(this).addClass('copied_elem');
                });
              }
              _context7.n = 3;
              break;
            case 5:
              //
              // We will provide hints automatically until you win at least twice
              //
              if (this.game.state.lifetime.wins < 1 && timeInterval > 0) {
                this.provideHint();
              }
              _context7.n = 7;
              break;
            case 6:
              _context7.p = 6;
              _t3 = _context7.v;
            case 7:
              return _context7.a(2);
          }
        }, _callee7, this, [[2, 6]]);
      }));
      function displayBoard() {
        return _displayBoard.apply(this, arguments);
      }
      return displayBoard;
    }()
    /*
    no status atm, but this is to update the hud
    */
  }, {
    key: "displayUserInterface",
    value: function displayUserInterface() {
      var html = '<span>Arrange the cards from 2 to 10, one suit per row by moving cards into empty spaces. </span>';
      var option = "<ul><li class=\"option\"";
      if (this.game.state.recycles_remaining > 0) {
        html += '<span>You may shuffle the unarranged cards ';
        if (this.game.state.recycles_remaining == 2) {
          html += '<strong>two</strong> more times.';
        } else {
          html += '<strong>one</strong> more time.';
        }
        html += '</span>';
        option += " id=\"shuffle\">Shuffle cards";
      } else {
        option += " id=\"quit\">New Game";
      }
      option += "</li><li class=\"option\" id=\"hint\">Hint";
      if (this.moves.length > 0) {
        option += "</li><li class=\"option\" id=\"undo\">Undo";
      }
      option += '</li></ul>';
      this.updateStatusWithOptions(html, option);
      this.attachHUDEvents();
    }
  }, {
    key: "attachHUDEvents",
    value: function attachHUDEvents() {
      var solitrio_self = this;
      $('.option').off();
      $('.option').on('click', /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8() {
        var action, last_move;
        return _regenerator().w(function (_context8) {
          while (1) switch (_context8.n) {
            case 0:
              action = $(this).attr('id');
              $('#rowbox').removeClass('nomoves');
              if (!(action == 'shuffle')) {
                _context8.n = 1;
                break;
              }
              solitrio_self.updateStatusWithOptions('shuffle cards...');
              solitrio_self.prependMove('shuffle');
              solitrio_self.endTurn();
              return _context8.a(2);
            case 1:
              if (!(action == 'quit')) {
                _context8.n = 4;
                break;
              }
              last_move = solitrio_self.moves.shift();
              if (!(last_move && (last_move == 'win' || last_move == 'lose'))) {
                _context8.n = 2;
                break;
              }
              solitrio_self.prependMove(last_move);
              _context8.n = 3;
              break;
            case 2:
              solitrio_self.prependMove(last_move);
              solitrio_self.prependMove('lose');
              _context8.n = 3;
              return solitrio_self.clearTable();
            case 3:
              solitrio_self.endTurn();
              return _context8.a(2);
            case 4:
              if (!(action == 'undo')) {
                _context8.n = 5;
                break;
              }
              solitrio_self.undoMove();
              return _context8.a(2);
            case 5:
              if (!(action == 'hint')) {
                _context8.n = 6;
                break;
              }
              solitrio_self.provideHint();
              return _context8.a(2);
            case 6:
              return _context8.a(2);
          }
        }, _callee8, this);
      })));
    }
  }, {
    key: "returnCardImageHTML",
    value: function returnCardImageHTML(name) {
      if (name[0] == 'E') {
        return '';
      } else {
        return "<img src=\"".concat(this.card_img_dir, "/").concat(name, ".png\" />");
      }
    }
  }, {
    key: "returnDeck",
    value: function returnDeck() {
      var suits = ['S', 'C', 'H', 'D', 'E'];
      var deck = {};
      /* WTF is with this indexing system??? */
      //2-10 of each suit, with indexing gaps on the 1's
      for (var i = 0; i < 4; i++) for (var j = 2; j <= 10; j++) {
        var index = 10 * i + j;
        //deck[index.toString()] = suits[i]+j;
        var name = suits[i] + j;
        deck[name] = name;
      }
      //E[mpty] slots (1-4) into '41'-'44'
      for (var _j = 1; _j <= 4; _j++) {
        var _index = 40 + _j;
        //deck[index.toString()] = suits[4]+j;
        var _name = suits[4] + _j;
        deck[_name] = _name;
      }
      return deck;
    }

    /*
     Combo function to check if in winning board state
     and shuffle cards that are not in winning positions
     */
  }, {
    key: "scanBoard",
    value: function () {
      var _scanBoard = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9() {
        var recycle,
          rows,
          myarray,
          i,
          rowsuite,
          j,
          slot,
          suite,
          num,
          _i,
          _j2,
          divname,
          winningGame,
          _i2,
          _j3,
          _divname,
          _args9 = arguments;
        return _regenerator().w(function (_context9) {
          while (1) switch (_context9.n) {
            case 0:
              recycle = _args9.length > 0 && _args9[0] !== undefined ? _args9[0] : true;
              rows = new Array(4);
              rows.fill(0);
              if (recycle) {
                $('.option').off();
                $('.slot').off();
              }
              myarray = [];
              /*
                  For each row of cards, if a 2 is in the left most position, 
                  find the length of the sequential streak of same suit
                */
              i = 0;
            case 1:
              if (!(i < 4)) {
                _context9.n = 6;
                break;
              }
              rowsuite = 'none';
              j = 1;
            case 2:
              if (!(j < 10)) {
                _context9.n = 5;
                break;
              }
              //Don't read last slot in each row
              slot = 'row' + (i + 1) + '_slot' + j;
              suite = this.returnCardSuite(slot);
              num = this.returnCardNumber(slot);
              if (j == 1 && num == 2) {
                rowsuite = suite;
              }
              if (!(rowsuite === suite && num == j + 1)) {
                _context9.n = 3;
                break;
              }
              rows[i] = j;
              if (recycle) this.toggleCard(slot);
              _context9.n = 4;
              break;
            case 3:
              return _context9.a(3, 5);
            case 4:
              j++;
              _context9.n = 2;
              break;
            case 5:
              i++;
              _context9.n = 1;
              break;
            case 6:
              _i = 0;
            case 7:
              if (!(_i < 4)) {
                _context9.n = 12;
                break;
              }
              _j2 = rows[_i] + 1;
            case 8:
              if (!(_j2 < 11)) {
                _context9.n = 11;
                break;
              }
              divname = "row".concat(_i + 1, "_slot").concat(_j2);
              if (!recycle) {
                _context9.n = 9;
                break;
              }
              this.hideCard(divname);
              _context9.n = 9;
              return this.timeout(25);
            case 9:
              myarray.push(this.game.board[divname]);
            case 10:
              _j2++;
              _context9.n = 8;
              break;
            case 11:
              _i++;
              _context9.n = 7;
              break;
            case 12:
              winningGame = myarray.length === 4;
              if (recycle) {
                //shuffle array, best method?
                myarray.sort(function () {
                  return Math.random() - 0.5;
                });

                //refill board

                for (_i2 = 0; _i2 < 4; _i2++) {
                  for (_j3 = rows[_i2] + 1; _j3 < 11; _j3++) {
                    _divname = "row".concat(_i2 + 1, "_slot").concat(_j3);
                    this.game.board[_divname] = myarray.shift();
                  }
                }
                this.boardToHand();
                this.endTurn();
              }
              return _context9.a(2, winningGame);
          }
        }, _callee9, this);
      }));
      function scanBoard() {
        return _scanBoard.apply(this, arguments);
      }
      return scanBoard;
    }()
  }, {
    key: "provideHint",
    value: function () {
      var _provideHint = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee0() {
        var emptySlots, i, targets, _i3, _emptySlots, slot, predecessor, cardValue, _i4, _t4, _t5;
        return _regenerator().w(function (_context0) {
          while (1) switch (_context0.n) {
            case 0:
              emptySlots = [];
              for (i in this.game.board) {
                if (this.game.board[i][0] == 'E') {
                  emptySlots.push(i);
                }
              }
              targets = [];
              for (_i3 = 0, _emptySlots = emptySlots; _i3 < _emptySlots.length; _i3++) {
                slot = _emptySlots[_i3];
                predecessor = this.getPredecessor(slot);
                if (predecessor) {
                  cardValue = parseInt(this.returnCardNumber(predecessor)) + 1;
                  if (cardValue < 11) {
                    targets.push(this.returnCardSuite(predecessor) + cardValue);
                  }
                } else {
                  targets = targets.concat(['D2', 'H2', 'S2', 'C2']);
                }
              }
              _t4 = _regeneratorKeys(this.game.board);
            case 1:
              if ((_t5 = _t4()).done) {
                _context0.n = 3;
                break;
              }
              _i4 = _t5.value;
              if (!targets.includes(this.game.board[_i4])) {
                _context0.n = 2;
                break;
              }
              $("#".concat(_i4)).toggleClass('misclick');
              _context0.n = 2;
              return this.timeout(150);
            case 2:
              _context0.n = 1;
              break;
            case 3:
              return _context0.a(2);
          }
        }, _callee0, this);
      }));
      function provideHint() {
        return _provideHint.apply(this, arguments);
      }
      return provideHint;
    }()
  }, {
    key: "returnCardSuite",
    value: function returnCardSuite(slot) {
      var card = this.game.board[slot];
      return card[0];
    }
  }, {
    key: "cardSuitHTML",
    value: function cardSuitHTML(suit) {
      switch (suit) {
        case 'D':
          return '&diams;';
        case 'H':
          return '&hearts;';
        case 'S':
          return '&spades;';
        case 'C':
          return '&clubs;';
        default:
          return '';
      }
    }
  }, {
    key: "returnCardNumber",
    value: function returnCardNumber(slot) {
      var card = this.game.board[slot];
      if (card[0] === 'E')
        //empty slot
        return 11;
      return card.substring(1);
    }
  }]);
}(OnePlayerGameTemplate);
module.exports = Solitrio;